export default __webpack_public_path__ + "static/media/CNo.61-3.ea2e4a9d.jpg";